export default __webpack_public_path__ + "locales/statements.bua.json";